import { render, staticRenderFns } from "./ReservasBarco.vue?vue&type=template&id=9102c2c8&scoped=true"
import script from "./ReservasBarco.vue?vue&type=script&lang=js"
export * from "./ReservasBarco.vue?vue&type=script&lang=js"
import style0 from "./ReservasBarco.vue?vue&type=style&index=0&id=9102c2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9102c2c8",
  null
  
)

export default component.exports